function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import { useIsInverseVariant as e } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const h = (_param)=>{
    var { color: l , size: c = 24  } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const t = e(), n = l !== null && l !== void 0 ? l : t ? o.colors.inverse : o.colors.neutralHigh;
    return /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ a("path", {
            fill: n,
            d: "M15.41 3.709h1.849c.714 0 1.3.56 1.3 1.252v1.924a.443.443 0 01-.015.107c-.106 1.792-1.215 2.767-3.134 2.767-.692 0-1.266-.14-1.742-.39-.482.911-.804 1.903-1.006 2.676h4.003c.717 0 1.3.56 1.3 1.246v1.493c0 .664-.55 1.205-1.233 1.238l-.549 4.774c.003.554-.504 1.041-1.129 1.041H8.928c-.622 0-1.131-.487-1.131-1.086l-.544-4.729c-.683-.033-1.232-.574-1.232-1.238v-1.493c0-.686.582-1.246 1.297-1.246h3.963a.02.02 0 00-.003-.009.02.02 0 01-.002-.008c-.166-1.854-.541-3.204-.975-4.185-.482.25-1.05.375-1.714.375-1.93 0-3.042-.988-3.14-2.784a.482.482 0 01-.014-.103V3.409c0-.695.585-1.258 1.305-1.258h1.854c2.034 0 3.154 1.076 3.157 3.031 0 .807-.205 1.479-.613 1.994-.009.006-.014.014-.02.023l-.115.126c.44.933.818 2.19 1.03 3.837a12.31 12.31 0 01.95-2.305l-.215-.269c-.342-.515-.504-1.129-.504-1.857 0-1.921 1.145-3.022 3.148-3.022zM8.59 7.4c.537 0 .988-.096 1.344-.28-.871-1.496-1.818-1.793-1.835-1.796h-.005a.409.409 0 01-.289-.501.426.426 0 01.513-.286c.08.02 1.215.342 2.243 1.986.222-.353.34-.799.34-1.34 0-1.492-.754-2.218-2.306-2.218H6.741a.45.45 0 00-.457.443v1.865a.315.315 0 01.011.09c.06 1.364.81 2.037 2.294 2.037zm9.117-.575l.003-1.87a.441.441 0 00-.451-.432h-1.846c-1.546 0-2.3.722-2.3 2.207 0 .56.115 1.017.34 1.367.649-.922 1.484-1.653 2.568-1.958a.428.428 0 01.528.284l.001.007a.405.405 0 01-.291.493c-.91.255-1.62.928-2.168 1.743.347.179.781.277 1.32.277 1.478 0 2.226-.667 2.285-2.042a.34.34 0 01.011-.076zm-.594 6.465a.437.437 0 00-.448-.428H7.318a.44.44 0 00-.449.431v1.493a.44.44 0 00.449.429h9.347a.44.44 0 00.448-.432V13.29zm-2.056 7.731c.154 0 .28-.123.28-.271l.535-4.72H8.105l.538 4.678c.002.19.128.313.285.313h6.13z"
        })
    }));
}, m = h;
export { m as default };
